// extracted by mini-css-extract-plugin
export default {"root":"prY5yyRcE8W1p6NCyaR1","wrap":"hQW64ugF3Z_feNZcdCLG","avatar":"NN_nT_5BGxfoLhVFGEtv","link":"XbuPUoynw0ajaBkwYs8d","trunc":"Vfnk4qkMvd7jNsxMkt08"};